import React from 'react';
import { connect } from 'react-redux';
import fields, { globalFieldLengths } from '@/constants/fields';
import VocabularyLinkInput from '../components/VocabularyLinkInput';
import VocabularyLinkValueContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/VocabularyLinkValueContainer';

const VocabularyLinkName = ({
  name,
  linkUUID,
  exists,
  canRead,
  updateProperties,
  maxLength = globalFieldLengths.name,
  updateErrors,
}) => {
  const updateLinkName = (value) => (
    updateProperties(linkUUID, { name: value })
  );

  const error = updateErrors.find((e) => (
    e.context.linkUUID === linkUUID && e.fields.includes(fields.NAME)));

  return (
    <VocabularyLinkValueContainer exists={exists} canRead={canRead}>
      <VocabularyLinkInput
        error={error !== undefined}
        fluid
        type="name"
        text={name}
        onChange={updateLinkName}
        maxLength={maxLength}
      />
    </VocabularyLinkValueContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyLinkName);
